import {toastr} from 'react-redux-toastr';
import {
  getJsonAsync,
  postJsonAsync,
  putJsonAsync
} from 'shared/actions';
import {loadTournament} from '../actions';
import {
  setTournamentStatus,
  setAvailableStatuses,
  publishStarts,
  publishEnds,
  cancelConfirmStatusChangeModal,
  setExportSystemInfo,
  loadingStarts,
  loadingEnds,
  setExportStatus
} from './actionTypes';

export const handleSetStatusClick = status => (dispatch, getState) => {
  const tournamentId = getState().tournament.base.tournamentInfo.id;
  const isExport = getState().tournament.status.systemShouldExport;

  const data = {
    "statusName": status,
    "isExport": isExport
  };

  dispatch(putJsonAsync(`setup/tournament/${tournamentId}/status`, data))
  .then(() => {
    toastr.success('Status Changed!', 'Tournament status successfully changed.');
    dispatch(cancelConfirmStatusChangeModal());
    dispatch(setTournamentStatus(status));
    dispatch(retrieveAvailableStatuses());
  })
  .catch(() => dispatch(cancelConfirmStatusChangeModal()));
};

export const retrieveAvailableStatuses = () => dispatch => {
  dispatch(getJsonAsync('setup/tournament/status'))
  .then(statuses => dispatch(setAvailableStatuses(statuses)));
};

export const handlePublish = () => (dispatch, getState) => {
  const tournamentId = getState().tournament.base.tournamentInfo.id;

  dispatch(publishStarts());
  dispatch(postJsonAsync(`setup/tournament/${tournamentId}/publish`))
  .then(() => {
    dispatch(publishEnds());
    toastr.success('Published!', 'Tournament published successfully.');
    dispatch(loadTournament(tournamentId));
  })
  .catch(() => dispatch(publishEnds()));
};

export const retrieveExportSystemName = () => (dispatch, getState)  => {
  const exportId = getState().tournament.base.tournamentInfo.exportId;

  dispatch(loadingStarts());
  dispatch(getJsonAsync(`export/tournament`)).then(data => {
    const exportSystem = data.find(x => x.id === exportId);
    const exportSystemName = exportSystem ? exportSystem.description : '';
    const systemShouldExport = exportSystem ? exportSystem.isExport : false;
    
    dispatch(setExportSystemInfo({ exportSystemName, systemShouldExport }));
    dispatch(loadingEnds());
  });  
};

export const handleExport = () => (dispatch, getState) => {
  const tournamentId = getState().tournament.base.tournamentInfo.id;
  
  dispatch(publishStarts());
  dispatch(postJsonAsync(`export/tournament/${tournamentId}`))
  .then(response => {
    dispatch(publishEnds());
    toastr.success('Exported!', 'Tournament exported successfully.');
    dispatch(loadTournament(tournamentId));

    download("Tournament.JSON", response);
  })
  .catch(() => dispatch(publishEnds()));
};

export const handleBeginExport = () => (dispatch, getState) => {
  const tournamentId = getState().tournament.base.tournamentInfo.id;
  
  dispatch(publishStarts());
  dispatch(postJsonAsync(`export/tournament/${tournamentId}/BeginExport`))
  .then(() => {
    dispatch(publishEnds());
    toastr.success('Exported Started!', 'We have begun to export your tournament.');
    dispatch(loadTournament(tournamentId)).then((data) => {
      dispatch(setExportStatusData(data));
    });
  })
  .catch(() => dispatch(publishEnds()));
};

const download = (filename, text) => {
  const a = document.createElement('a');
  const blob = new Blob([JSON.stringify(text)], { type: 'application/text' });
  const url = window.URL.createObjectURL(blob);
  
  if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
    return navigator.msSaveBlob(blob, filename);
  } else {
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
};

export const handleDownloadExport = () => (dispatch, getState) => {
  const tournamentId = getState().tournament.base.tournamentInfo.id;
  const exportFileName = getState().tournament.status.exportFileName || 'Tournament.json';
  
  dispatch(getJsonAsync(`export/tournament/${tournamentId}/downloadexport`))
  .then(response => {
    download(exportFileName, response);
  });
};
 
export const setExportStatusData = (data) => dispatch => {
  const exportStatus = data.exportStatus;
  const exportFileLocation = data.exportFileLocation;
  const exportFileName = data.exportFileName;
  
  dispatch(setExportStatus({ exportStatus, exportFileLocation, exportFileName }));
};


// WEBPACK FOOTER //
// ./src/features/tournament/status/actions.js